import { Grid, Typography } from "@mui/material";
import React from "react";
import {
  borderDegug,
  componentSpace,
  componentSpaceMobile,
  lineHeight,
  lineHeightMobile,
  maxWidthWaitingList,
  smallSpace,
  styles,
} from "../../../theme/styles";
import { WaitingList } from "./WaitingList";
import { useMediaQuery, useTheme } from "@mui/material";

// Interface
interface CardProps {
  title?: string;
  subtitle?: string;
  style?: React.CSSProperties;
}

export const InGameWaitingList = ({ title, subtitle, style }: CardProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <Grid
      item
      md={6}
      xs={12}
      style={
        isDesktop
          ? {
              marginTop: componentSpace,
              border: borderDegug,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
              padding: "0",
              textAlign: "left",
            }
          : {
              marginTop: componentSpaceMobile,
              border: borderDegug,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
              padding: "0",
              textAlign: "center",
            }
      }
    >
      {isDesktop ? (
        <>
          <Typography
            variant="h4"
            style={{
              border: borderDegug,
              marginBottom: "1%",
              maxWidth: maxWidthWaitingList,
              lineHeight,
              marginTop: smallSpace,
            }}
          >
            Sempre <label style={styles.label}> pronto</label> para o{" "}
            <label style={styles.label}>jogo</label>
          </Typography>

          <Typography
            variant="h6"
            style={{
              border: borderDegug,
              fontSize: "13.8px",
              maxWidth: maxWidthWaitingList,
            }}
          >
            Possibilitando o treinamento de qualidade com preços acessíveis
          </Typography>
        </>
      ) : (
        <>
          <Typography
            variant="h4"
            style={{
              border: borderDegug,
              marginBottom: "1%",
              maxWidth: maxWidthWaitingList,
              lineHeight,
            }}
          >
            Sempre <label style={styles.label}> pronto</label> <br />
            para o <label style={styles.label}>jogo</label>
          </Typography>

          <Typography
            variant="h6"
            style={{
              border: borderDegug,
              fontSize: "13.8px",
              maxWidth: maxWidthWaitingList,
              lineHeight: lineHeightMobile,
              marginTop: smallSpace,
            }}
          >
            Possibilitando o treinamento de qualidade
            <br /> com preços acessíveis.
          </Typography>
        </>
      )}
      <WaitingList></WaitingList>
    </Grid>
  );
};
